/** Switch control themed with design tokens. `size` defaults to "md"; "sm" is a compact variant for dense tables. */
export function Switch({
  checked,
  onCheckedChange,
  disabled,
  size = "md",
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}) {
  const track = size === "sm" ? "h-4 w-7" : "h-6 w-11";
  const knob = size === "sm" ? "h-3 w-3" : "h-4 w-4";
  const knobOn = size === "sm" ? "translate-x-3.5" : "translate-x-6";
  const knobOff = size === "sm" ? "translate-x-0.5" : "translate-x-1";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={`relative inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${track} ${checked ? "bg-primary" : "bg-input"}`}
    >
      <span className={`pointer-events-none block rounded-full bg-background shadow-md ring-0 transition-transform ${knob} ${checked ? knobOn : knobOff}`} />
    </button>
  );
}
